import React from 'react';
import '../styles/main.scss';

const BlankLayout = (props: any) => <>{props.children}</>;

export default BlankLayout;
